export const teamMemberData = [
  {
    name: "Mary Crover",
    title: "Lead Singer and Songwriter",
    subtitles:
      "Lead Singer, Lead Songwriter, Performer, Recording Artist, Guitarist, Keys, Djimbe",
    description: `Mary has written poetry since her early teens and transitioned to songwriting more than 30 years ago after learning guitar. She began her performance career in musical theatre and as a host of open mics and karaoke and is now the lead singer and primary songwriter for Back Alley Prophet. She also performs locally as part of the duet Crazy Diamond. 
    Guided by raw authenticity and creative presence, her work speaks to the power of reflection and self-expression in the present moment.

`,
    quote: `"How wildly fortunate I  am to be travelling this musical journey with my fellow Back Alley Prophet members.  Each one brings something special and needed to this mix"`,
    memberType: "Core",
    socialLinks: [
      // { url: '#', icon: 'fab fa-facebook-f' },
      // { url: '#', icon: 'fab fa-instagram' },
      // { url: '#', icon: 'fab fa-twitter' },
    ],
  },
  {
    name: "Jeff Stones",
    title: "Bass Guitar",
    subtitles: "Bass, Guitarist, Singer, Songwriter, Recording Artist",
    description: `Jeff’s initial inclination at age 14 was towards pop, rock, blues and country music. That evolved when he picked up his first instrument, the sax. He soon moved on to playing the bass and electric guitar with like-minded musicians, covering tunes from the 60’s, 70’s and 80’s.
                  Music influences include Deep Purple, Genesis and Neil Young.`,
    quote: `"Music has been a source of enjoyment from childhood. It was always in my house and my
parents encouraged me to pick up an instrument and learn to play. I started to go to see bands live as a teenager and to this day, see live bands either in a bar or a stadium, even an airfield. Playing music and seeing bands on stage fills my heart and feeds my soul."`,
    memberType: "Core",
    socialLinks: [
      // { url: '#', icon: 'fab fa-facebook-f' },
      // { url: '#', icon: 'fab fa-instagram' },
      // { url: '#', icon: 'fab fa-twitter' },
    ],
  },
  {
    name: "Tony Callahan",
    title: "Lead Guitarist",
    subtitles: "Lead Guitarist",
    description: `Tony brings a history of several music genres and is accomplished in several instruments, playing drums, bass, rhythm and lead guitar.    Tony has been playing gigs with Back Alley Prophet since the Fall of 2024.

Tony also sings, writes music and collaborates in songwriting and records.

Tony has been performing in the Durham Toronto areas for several years, with various local bands and is well-known for his time with  Brownsmith, a popular local band.`,
    memberType: "Honorary",
    socialLinks: [
      // { url: '#', icon: 'fab fa-facebook-f' },
      // { url: '#', icon: 'fab fa-instagram' },
      // { url: '#', icon: 'fab fa-twitter' },
    ],
  },
  // {
  //   name: "James Hunter",
  //   title: "Drummer",
  //   subtitles: "Drummer",
  //   description: `James joined Back Alley in 2023 and has performed with various bands over the years James plays genres of all kinds, Motown, Rock, Blues, Pop.  You name it, James holds down the beat.`,
  //      memberType: "Honorary",
  //   socialLinks: [
  //     // { url: '#', icon: 'fab fa-facebook-f' },
  //     // { url: '#', icon: 'fab fa-instagram' },
  //     // { url: '#', icon: 'fab fa-twitter' },
  //   ],
  // },

  {
    name: "Paul Lalla",
    title: "Lead Guitarist",
    subtitles: "Guitarist, Singer, Songwriter, Recording Artist",
    description: `Paul (A.K.A. Rusty Cage) started playing guitar at age 12 and never looked back. "I’m still writing and performing and having fun!"`,
    quote: `"If you can't laugh as hard as you cry, what is life!!"`,
    memberType: "none",
    socialLinks: [
      // { url: '#', icon: 'fab fa-facebook-f' },
      // { url: '#', icon: 'fab fa-instagram' },
      // { url: '#', icon: 'fab fa-twitter' },
    ],
  },

  {
    name: "Dennis Hebert",
    title: "Guitarist, Singer",
    subtitles: "Rhythm Guitarist, Singer, Drummer",
    description: `Dennis came from a family of musicians and has been disturbing the peace and neighbors since the age of 14 with influences such as Rush, Led Zeppelin, Lynyrd Skynyrd, ZZ Top, Stevie Ray Vaughan and Bob Segar.
 
Once Dennis connected with New Country music, the gigs flowed for the next 20 years. Playing in and around the GTA in various bars, legion halls and private events his band grew from a family trio to becoming a power trio and eventually Dennis was fronting the Country band, "Mustang" as a powerhouse lead singer for over ten years.
Music influences include Rush, Led Zeppelin and Lynyrd Skynyrd.
`,
    quote: `"Coming full circle with Back Alley Prophet and going back to my southern rock and blues roots is like a homecoming. Looking forward to seeing dancers on the floor and playing that toe tapping music."`,
    memberType: "Core",
    socialLinks: [
      // { url: '#', icon: 'fab fa-facebook-f' },
      // { url: '#', icon: 'fab fa-instagram' },
      // { url: '#', icon: 'fab fa-twitter' },
    ],
  },

  {
    name: "Sara Campbell",
    title: "Guest Harpist, Singer, Guitarist",
    subtitles: "Guest Harpist, Singer, Guitarist",
    description: `Sara plays harmonica, mandolin, electric and acoustic guitar, sings lead and back-up vocals and is a show on her own with the many instruments she plays.

Like an extended family member, Sara joins Back Alley Prophet as our honorary member, playing harmonica and guitar as well as  providing back up vocals and filling in when needed.

Sara, along with Mary Crover,  is part of a duet called Crazy Diamond and they perform at restaurant bars, private parties and outdoor markets and festivals. 

Sara has been on the Durham music scene for decades performing in live bands, hosting open mics and working on various musical collaborations.
`,
    quote: ``,
    memberType: "Honorary",
    socialLinks: [
      // { url: '#', icon: 'fab fa-facebook-f' },
      // { url: '#', icon: 'fab fa-instagram' },
      // { url: '#', icon: 'fab fa-twitter' },
    ],
  },

  {
    name: "Ron Del",
    title: "Drummer",
    subtitles: "Drummer",
    description: `Just your weekend warrier playing in local bands since my 20’s. I hope my enjoyment of the instrument shows through in my playing, trying to lock a groove, maybe throw in a few sprinkles, but letting the band be comfortable and shine in their performance.`,
    memberType: "Core",
    socialLinks: [
      // { url: '#', icon: 'fab fa-facebook-f' },
      // { url: '#', icon: 'fab fa-instagram' },
      // { url: '#', icon: 'fab fa-twitter' },
    ],
  },
  {
    name: "Jake Lecuyer",
    title: "Lead Guitarist",
    subtitles: "Lead Guitarist",
    description: `Jake brings a lifetime of music to the stage. From the age of 14 he was playing in
bars with bands and in demand from the top bands in and around the Ottawa Valley.
Taking to the road at an early age with his own power trio he crossed the United
States touring and gaining valuable experience. Once back home he was a sought
after lead guitar player through out the GTA. Settling on a long stint with ‘Mustang’,
first as another Power Trio then a rockin’ four piece country band. He brings depth
and feeling to all of his powerful leads.`,
    memberType: "Core",
    socialLinks: [
      // { url: '#', icon: 'fab fa-facebook-f' },
      // { url: '#', icon: 'fab fa-instagram' },
      // { url: '#', icon: 'fab fa-twitter' },
    ],
  },
];
